import { useCallback, useEffect, useState } from "react";

import { useNotify, useSubscribe } from "data/messages/hooks";

export function useSubscribeToClientCardNextWorkflows(onUpdate) {
  const [isRefetch, refetch] = useState(false);
  const notify = useNotify("CLIENT_CARD_NEXT_WORKFLOWS");

  useEffect(() => {
    if (isRefetch) {
      onUpdate();
      refetch(false);
      notify([]);
    }
  }, [isRefetch, onUpdate, notify]);

  useSubscribe(
    "clientCardNextWorkflows",
    useCallback((reloadSet) => {
      if (reloadSet && reloadSet.values().next().value) refetch(true);
    }, [])
  );
}

export default useSubscribeToClientCardNextWorkflows;
